export type TFAQList = { question: string; answer: string | string[] }
export const FAQList: TFAQList[] = [
    {
        question: 'Who can apply for Demo Day?',
        answer: 'Anyone with a startup at the idea, prototype, MVP, or early traction stage is welcome to apply. We support both tech and non-tech ventures.'
    },
    {
        question: 'What is the selection process?',
        answer: 'Once you submit your startup, it goes through an expert assessment. Top startups are shortlisted to pitch live to investors'
    },
    {
        question: 'Is there a registration fee?',
        answer: 'Yes, a nominal fee is charged to ensure commitment and to support the platform experience. The fee includes multiple founder benefits (see below).'
    },
    {
        question: 'What do I get for the registration fee?',
        answer: [
            'Investor-ready profile on VentureVerse',
            'Access to mentorship sessions & high value webinar sessions',
            'Discounts to high value resources',
            'Entry into the Demo Day pitch shortlist',
            'Community exposure and certification'
        ]
    },
    {
        question: 'Will I pitch live in front of investors?',
        answer: 'Shortlisted startups will be invited to pitch live. Others will still be featured in Venture Verse and may receive investor visibility post-event'
    },
    {
        question: ' What if I am not selected for live pitch?',
        answer: 'Shortlisted startups will be invited to pitch live. Others will still be featured in Venture Verse and may receive investor visibility post-event'
    },
    {
        question: 'Will I pitch live in front of investors?',
        answer: [
            'Even if you re not selected for the final pitch, your startup remains discoverable on Venture Verse and can still attract interest from mentors, investors, and partners.',
            'With feedbacks received, you can apply for our upcoming demo days'
        ]
    },
    {
        question: 'Can a non-tech start-up apply?',
        answer: 'Yes! htraction supports both tech and non-tech ideas, innovation and clarity of execution matter more than just code.'
    },
    {
        question: 'Can I interact with investors outside the pitch?',
        answer: 'Yes. We can facilitate 1:1 follow-ups after the event if mutually you and investor would like to explore further'
    },
    {
        question: 'My start-up isnt selected for the pitch to investor. Can I attend Demo Day as an observer?',
        answer: 'Yes! If you have registered for demo day and if your start-up isnt selected, you can still watch the live pitch as observer'
    },
    {
        question: 'Will the event be recorded?',
        answer: 'Yes, but recording will be shared to only those who pitched'
    },
    {
        question: 'How can I get in touch with your team?',
        answer: "We're here to help! You can contact us by emailing us at "
    }
]
